<template>
    <div>
      <Header />
      <main class="container mt-5">
        <h6 class="text-center mb-4">{{ $t('privacy_policy.title') }}</h6>
  
        <section class="mb-5">
          <h2 class="text-primary">{{ $t('privacy_policy.intro') }}</h2>
        </section>
  
        <section class="mb-5">
          <h2 class="text-primary">{{ $t('privacy_policy.data_collection.title') }}</h2>
          <p>{{ $t('privacy_policy.data_collection.content') }}</p>
        </section>
  
        <section class="mb-5">
          <h2 class="text-primary">{{ $t('privacy_policy.data_use.title') }}</h2>
          <p>{{ $t('privacy_policy.data_use.content') }}</p>
        </section>
  
        <section class="mb-5">
          <h2 class="text-primary">{{ $t('privacy_policy.data_protection.title') }}</h2>
          <p>{{ $t('privacy_policy.data_protection.content') }}</p>
        </section>
  
        <section class="mb-5">
          <h2 class="text-primary">{{ $t('privacy_policy.contact.title') }}</h2>
          <p>{{ $t('privacy_policy.contact.content') }}</p>
        </section>
      </main>
      <Footer />
    </div>
  </template>
  
  <script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  
  export default {
    components: {
      Header,
      Footer
    }
  }
  </script>
  